import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * This is a generic modal used to display messages with a dismiss button.
 * Anything more complex should have a separate component.
 */
@Component({
  selector: 'h3-message-modal',
  templateUrl: './message-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MessageModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      title: string;
      text: string;
    },
  ) {}
}
